// Modules
import Link from 'next/link';
import { Swiper, SwiperSlide } from 'swiper/react';
// Components
import CategoryPostCard from '~/components/category-post-card';
import CategoryPostsHeader from '~/components/category-posts-header';
// Styles
import styles from './category-posts-section.module.scss';

const CategoryPostsSection = ({ items, title, slug }) => {
  return (
    <article className={`${styles['wrapper']} container`}>
      <CategoryPostsHeader title={title} slug={slug} />

      <div className={styles['wrapper__content']}>
        <Swiper slidesPerView={'auto'}>
          {items?.slice(0, 4)?.map((item) => (
            <SwiperSlide
              key={item.id}
              style={{ width: 'auto' }}
              className={styles['wrapper__content__item']}
            >
              <Link href={`/video/${item?.slug}`} title={item?.title}>
                <CategoryPostCard data={item} />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </article>
  );
};

export default CategoryPostsSection;
